import styled from "styled-components";

export const VideoSectionContainer = styled.section`
  position: relative;
  margin: 50px 0;
  padding: 50px 0;
  background: #ff5f38;
  @media (max-width: 768px) {
    padding: 25px 0;
    margin: 0;
  }
`;

export const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
